import Api from 'services/api'

const API_AUTH_INSTANCE_LOGIN = '/auth/instance-login'

/** Trade the single-use code from admin.nexys.com for a normal staff session. */
export const exchangeInstanceLoginCode = (code: string): Promise<any> =>
  Api.post(API_AUTH_INSTANCE_LOGIN, { code })
